import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Handle chunk load errors - reload the page when a chunk fails to load
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('Loading chunk')) {
    console.log('[Chunk Error] Reloading to get updated chunks...');
    window.location.reload();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('Loading chunk')) {
    console.log('[Chunk Error] Reloading to get updated chunks...');
    window.location.reload();
  }
});

// Aggressively unregister any existing service workers across all environments
// to fix the infinite reload loop caused by stale chunk errors and domain conflicts.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  }).catch(() => {});
}
